import { ChangeEvent, ReactNode, useContext } from "react";
import { Stack, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AppContext } from "context/appContext";
import { Tenant } from "types";
import AuturaDropdown from "components/inputs/AuturaDropdown";

export interface TenantSelectWidgetProps {
  tenant: Tenant;
  setTenant: (tenant: Tenant) => void;
}

const TenantSelectWidget = ({
  tenant,
  setTenant,
}: TenantSelectWidgetProps): ReactNode => {
  const { t } = useTranslation();
  const { state } = useContext(AppContext);

  const handleSelectTenant = (e: ChangeEvent<HTMLInputElement>) => {
    const tenant = state.userTenants.find((t) => t.name === e.target.value);
    if (tenant) {
      setTenant(tenant);
    } else {
      setTenant(state.tenant);
    }
  };

  return (
    <Stack direction="column" spacing={0} flex={2}>
      <Grid container width={"100%"} spacing={3}>
        <Grid size={12}>
          <AuturaDropdown
            name="tenant"
            label={t("tenant.label", { ns: "entities" })}
            initialValue={tenant.name}
            value={tenant.name}
            setValue={handleSelectTenant}
            options={[...state.userTenants.map((t) => t.name)]}
            required
          />
        </Grid>
      </Grid>
    </Stack>
  );
};

export default TenantSelectWidget;
